import React from 'react';
import { VERGUNNING_CATEGORIEEN } from '../util/doelen';

/* Doelen kiezen: eerst de hoofdcategorie, dan de sub-doelen daaronder.

   Zat als losse JSX in het inrichtingsformulier en nog eens in de
   wijzigingsbesluitmodal. Eén component, zodat de twee schermen niet uit
   elkaar lopen — en zodat het uitvinken van een categorie op beide plekken
   dezelfde sub-doelen opruimt. */

export default function DoelenKiezer({ categorieen, doelen, onChange }) {
  const zetCategorie = (cat, aan) => {
    const nieuweCats = aan
      ? [...categorieen, cat.key]
      : categorieen.filter((k) => k !== cat.key);
    // Categorie uit? Dan gaan haar sub-doelen mee; anders blijven ze
    // onzichtbaar aangevinkt staan en worden ze straks wél opgeslagen.
    const weg = aan ? [] : cat.opties.map((o) => o.value);
    onChange({
      categorieen: nieuweCats,
      doelen: (doelen || []).filter((d) => !weg.includes(d)),
    });
  };

  const zetDoel = (waarde, aan) => onChange({
    categorieen,
    doelen: aan ? [...(doelen || []), waarde] : (doelen || []).filter((d) => d !== waarde),
  });

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
        {VERGUNNING_CATEGORIEEN.map((cat) => {
          const aan = categorieen.includes(cat.key);
          return (
            <label key={cat.key} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
              <input type="checkbox" checked={aan} onChange={() => zetCategorie(cat, !aan)} />
              <span style={{ fontWeight: 500 }}>{cat.label}</span>
            </label>
          );
        })}
      </div>
      {categorieen.length > 0 && (
        <div style={{ borderTop: '1px solid var(--separator)', paddingTop: 12 }}>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 8 }}>Sub-doelen</div>
          {VERGUNNING_CATEGORIEEN
            .filter((cat) => categorieen.includes(cat.key))
            .map((cat) => (
              <div key={cat.key} style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 6 }}>{cat.label}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, paddingLeft: 8 }}>
                  {cat.opties.map((opt) => {
                    const aan = (doelen || []).includes(opt.value);
                    return (
                      <label key={opt.value} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                        <input type="checkbox" checked={aan} onChange={() => zetDoel(opt.value, !aan)} />
                        <span>{opt.label}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
            ))}
        </div>
      )}
    </>
  );
}
